export default __webpack_public_path__ + "static/media/Calender_Grey_Icon.7529b1b0.svg";